import Link from 'next/link'

import styles from './styles.module.scss'
import Image from 'next/image'

interface Props {
  src: string
  author: string
  path: string
  companyName: string
}

export const AuthorCard: React.FC<Props> = ({
  author,
  path,
  src,
  companyName
}) => {
  return (
    <Link href={path} passHref>
      <div className={styles.container}>
        <div className={styles.figure}>
          <Image
            width={120}
            height={120}
            alt={author}
            src={src || '/assets/raio-laranja.svg'}
            className={styles.avatar}
            loading="lazy"
          />
        </div>
        <span className="font-robotoSlab text-lg text-center">{author}</span>
        <span className="font-robotoSlab text-sm text-center">
          {companyName}
        </span>
      </div>
    </Link>
  )
}
